import React from 'react';
import { useLang } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './Contact.css';

export default function Contact() {
  const { t } = useLang();
  const headerRef = useScrollReveal();
  const bodyRef = useScrollReveal();

  return (
    <section id="contact" className="contact">
      <div className="contact__inner">
        <div ref={headerRef} className="section-label reveal">{t.contact.title}</div>
        <div ref={bodyRef} className="reveal reveal-delay-1">
          <div className="contact__details">
            <a href={`mailto:${t.contact.email}`} className="contact__link">
              <span className="contact__link-label">Email</span>
              <span>{t.contact.email}</span>
            </a>
            <a href={`tel:${t.contact.phone.replace(/\s/g, '')}`} className="contact__link">
              <span className="contact__link-label">Tel</span>
              <span>{t.contact.phone}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
